<template>
  <div v-if="paymentLog">
    <!--预收运费弹框-->
    <PaymentFeesDialog
      v-if="showPaymentFeesDialog"
      :showPaymentFeesDialog="showPaymentFeesDialog"
      :orderNo="payData.orderNo"
      @yufeidaofuSuccess="yufeidaofuSuccess"
      @yushouyunfeiSuccess="yushouyunfeiSuccess"
      @closePaymentFeesDialog="closePaymentFeesDialog"
    />
    <!-- 提交单运费弹框 -->
    <LadingFreightFeesDialog
      v-if="showLadingFreightOrSave"
      :showLadingFreightOrSave="showLadingFreightOrSave"
      :orderNo="payData.ladingNo"
      @ladingYunfeidaofuSuccess="ladingYunfeidaofuSuccess"
      @ladingYushouyunfeiSuccess="ladingYushouyunfeiSuccess"
      @closePaymentFeesDialog="closePaymentFeesDialog"
    />
    <!-- 付款弹出框 -->
    <FreightProcure2Pay
      v-if="freightVisiblePay"
      :dialogVisiblePay="freightVisiblePay"
      :orderId="payData.orderId"
      :campusId="payData.campusId"
      :orderNo="payData.orderNo"
      :orderType="orderType"
      @submitPay="submitPay"
      @cancelSubitPay="cancelSubitPay"
      @closeProcure2Pay="closeProcure2Pay"
      @bankRransferPay="bankRransferPay"
    />
    <!-- 提货单运费到付弹框 -->
    <LadingFreightProcure2Pay
      v-if="ladingFreightVisiblePay"
      :dialogVisiblePay="ladingFreightVisiblePay"
      :orderNo="payData.ladingNo"
      :orderType="orderType"
      @submitPay="submitPay"
      @cancelSubitPay="cancelSubitPay"
      @closeProcure2Pay="closeProcure2Pay"
      @bankRransferPay="bankRransferPay"
    />
    <!-- 付款弹出框 -->
    <Procure2Pay
      v-if="dialogVisiblePay"
      :dialogVisiblePay="dialogVisiblePay"
      :payData="payData"
      :orderId="payData.orderId"
      :orderType="orderType"
      @submitPay="submitPay"
      @cancelSubitPay="cancelSubitPay"
      @closeProcure2Pay="closeProcure2Pay"
      @bankRransferPay="bankRransferPay"
    />
    <!--微信、支付宝支付-->
    <Procure3Pay
      v-if="procure3PayDialog"
      :procure3PayDialog="procure3PayDialog"
      :elsePayMoney="formLabelAlign.elsePayMoney"
      :Choice="payType"
      :orderNo="payData.orderNo || payData.ladingNo"
      :orderType="orderType"
      @agentPaySuccess="agentPaySuccess"
      @paySuccess="paySuccess"
      @closeProcure3PayDialog="closeProcure3PayDialog"
    />
    <!--付款-对公转账-->
    <BankRransferModal
      v-if="bankRransferDialogVisible"
      :bankRransferDialogVisible="bankRransferDialogVisible"
      :payData="payData"
      :companyInfo="companyInfo"
      :formLabelAlign="formLabelAlign"
      @closeBankRransfer="closeBankRransfer"
      @bankRransferSuccess="bankRransferSuccess"
      :purchaseOrderPay="purchaseOrderPay"
    />
    <!--支付二次确认弹框-->
    <ConfirmDialog
      :dialogVisible="payDialogVisible"
      @dialogCancel="payDialogCancel"
      @dialogConfirm="payDialogConfirm"
    >
      <div class="dialog-content">
        <div class="order-kouchu-wrap">
          <p class="dialog-title">{{ $t('app.tip') }}</p>
          <p class="kouchu-tips">{{ $t('app.auto_11_3c1407e3') }}</p>
          <ul class="kouchu-money-ul" style="padding-left: 0;">
            <li>
              {{ $t('purchasing.voucherBonusAccount') }}：{{ $i18n.locale === 'en-US' ? $crmCurrencySymbol() : '' }}{{ this.formLabelAlign.voucherAccountPayMoney || 0 }}{{ $i18n.locale === 'en-US' ? '' : $crmCurrencySuffix() }}
            </li>
            <li v-if="$i18n.locale !== 'en-US'">{{ $t('purchasing.promotionFeeAccount') }}：{{ this.formLabelAlign.promoteMoney || 0 }}{{ $crmCurrencySuffix() }}</li>
            <li>{{ $t('purchasing.cashAccount') }}：{{ $i18n.locale === 'en-US' ? $crmCurrencySymbol() : '' }}{{ this.formLabelAlign.accountPayMoney }}{{ $i18n.locale === 'en-US' ? '' : $crmCurrencySuffix() }}</li>
            <li v-if="$i18n.locale !== 'en-US'">{{ $t('purchasing.goldAccount') }}：{{ this.formLabelAlign.totalGoldPayMoney }}{{ $crmCurrencySuffix() }}</li>
            <li v-if="$i18n.locale !== 'en-US'">{{ $t('purchasing.deliveryVoucherAccount') }}：{{ this.formLabelAlign.deliveryMoney }}{{ $crmCurrencySuffix() }}</li>
          </ul>
        </div>
      </div>
    </ConfirmDialog>
    <!--付款成功或者失败-->
    <el-dialog
      center=""
      :title="payResultTitle"
      custom-class="MyDialog pay-result-dialog"
      :visible.sync="showPayResultDialog"
      :show-close="false"
      width="500px"
    >
      <div class="pay-result">
        <template v-if="isSuccess">
          <img src="@/assets/images/agent/pay_success.png" />
          <p class="result-tips">{{ $t('purchasing.paySuccessAmount', { money, symbol: $crmCurrencySymbol(), unitSuffix: $crmCurrencySuffix() }) }}</p>
        </template>
        <template v-else>
          <img src="@/assets/images/agent/pay_fail.png" />
          <p class="result-tips">{{ $t('purchasing.payFailAmount', { money, symbol: $crmCurrencySymbol(), unitSuffix: $crmCurrencySuffix() }) }}</p>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="hidePayResultDialog"
          >{{ $t('app.gotIt') }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FreightProcure2Pay from "@/components/FreightProcure2Pay";
import LadingFreightProcure2Pay from "@/components/FreightProcure2Pay/ladingPay.vue"; // 提货单
import Procure3Pay from "@/components/Procure3Pay";
import BankRransferModal from "@/components/BankRransferModal";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import PaymentFeesDialog from "@/components/PaymentFeesDialog.vue";
import LadingFreightFeesDialog from "@/components/LadingFreightFeesDialog.vue";
import { queryCompanyInfo } from "@/api/AgentAccount";
import Procure2Pay from "@/components/Procure2Pay";

import { purchaseOrderPay, creditOrderPay, ladingPay } from "@/api/AccountInterface";
export default {
  props: {
    orderType: {
      type: String,
      default: "online"
    },
    payData: {
      type: Object,
      default: () => {},
    },
    callBackFn: {
      type: Function,
      default: () => {},
    },
    purchaseOrderPay: {
      type: Boolean, // 对公支付接口区分
      default: true,
    },
    payApi: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      paymentLog: false, // 支付弹框
      dialogVisiblePay: false, // 普通支付弹框
      freightVisiblePay: false, // 支付运费
      procure3PayDialog: false, // 微信、支付宝支付
      bankRransferDialogVisible: false, // 对公转账
      payDialogVisible: false, // 支付二次确认弹框
      showPayResultDialog: false, // 支付成功或者失败
      showPaymentFeesDialog: false, // 预收费弹框
      formLabelAlign: {}, // 支付弹框数据
      agentAccountObj: {},
      companyInfo: {}, // 公司信息
      payType: "", // 支付方式
      money: "", // 支付金额
      isSuccess: false, // 支付成功或者失败
      payResultTitle: "", // 支付成功或者失败标题
      dialogPayType: "", //
      showLadingFreightOrSave: false, // 提货运费弹框
      ladingFreightVisiblePay: false, // 提货单运费到付弹框
    };
  },
  components: {
    FreightProcure2Pay,
    LadingFreightProcure2Pay,
    ConfirmDialog,
    Procure3Pay,
    BankRransferModal,
    PaymentFeesDialog,
    LadingFreightFeesDialog,
    Procure2Pay,
  },
  computed: {
    // 是否是提货单
    isLading() {
      return this.payApi === "lading";
    }
  },
  mounted() {
    this.queryCompanyInfo();
  },
  methods: {
    /**
     * @param dict 打开支付弹框的类型
     * showPaymentFeesDialog 预收费弹框
     * dialogVisiblePay 直接支付弹框
     */
    openPaymentDialog(dict = "dialogVisiblePay") {
      this.dialogPayType = "";
      this.procure3PayDialog = false;
      this[dict] = true;
      this.paymentLog = true;
    },
    async queryCompanyInfo() {
      try {
        let { data, code, message } = await queryCompanyInfo();
        if (code === 0) {
          this.companyInfo = data;
        } else {
          this.$message.error(this.$getCodeMessage(code, message));
        }
      } catch (error) {
        // 捕获并处理 queryCompanyInfo 函数可能抛出的异常
        console.error(error);
        this.$message.error(this.$t('app.failed'));
      }
    },
    // 确认开始支付
    submitPay(fromPayData, payType, agentAccountObj, type) {
      console.log("fromPayData", fromPayData, type);
      this.dialogVisiblePay = false;
      this.freightVisiblePay = false;
      this.ladingFreightVisiblePay = false;
      this.formLabelAlign = fromPayData;
      this.payType = payType;
      if (type != "onlyAgentPay") {
        this.payDialogVisible = true;
      }
      this.payDialogVisible = true;
      if (type == "submitAndAgentPay") {
        this.dialogPayType = type;
      } else if (type == "paymentFN") {
        this.handleClick(this.payData);
        this.dialogPayType = type;
      } else if (type == "onlyAgentPay") {
        // 只有现金支付（支付宝、微信）
        this.agentPay();
      }
    },
    // 支付宝、微信
    agentPay() {
      this.payDialogVisible = false;
      this.procure3PayDialog = true;
    },
    paySuccess(money, isSuccess) {
      this.payResultTitle = isSuccess ? this.$t('app.auto_318_bdf9a706') : this.$t('app.auto_319_e0bf7ef9');
      this.money = money;
      this.isSuccess = isSuccess;
      this.showPayResultDialog = true;
    },
    agentPaySuccess() {
      this.callBackFn();
      this.procure3PayDialog = false;
    },
    handleClick(row) {
      console.log("xxdsds-----", row);
      // this.payData = row;
      this.procure3PayDialog = false;
      checkPurchaseOrderPay({ orderNo: row.orderNo }).then((ret) => {
        if (ret.code === 0) {
          this.dialogVisiblePay = true;
        } else {
          this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs));
        }
      });
    },
    payDialogConfirm() {
      this.submit();
    },
    // 对公转账
    bankRransferPay(formLabelAlign, payType, agentAccountObj) {
      this.dialogVisiblePay = false;
      this.freightVisiblePay = false;
      this.ladingFreightVisiblePay = false;
      this.bankRransferDialogVisible = true;
      this.formLabelAlign = formLabelAlign;
      this.payType = payType;
      this.agentAccountObj = agentAccountObj;
      console.log(
        "this.bankRransferDialogVisible",
        this.bankRransferDialogVisible
      );
    },
    // 提交订单
    submit() {
      const {
        accountPayMoney,
        deliveryMoney,
        voucherAccountPayMoney,
        totalGoldPayMoney,
        elsePayMoney,
        promoteMoney,
      } = this.formLabelAlign;
      const isUsLocale = this.$i18n && this.$i18n.locale === "en-US";
      const params = {
        agentMoney: accountPayMoney, //1
        realTimeMoney: 0,
        bankInfo: {
          fileUrl: [],
          money: 0,
          paySysNo: "",
          payTime: "",
          remark: "",
        },
        orderNo: this.isLading ? this.payData.ladingNo : this.payData.orderNo, //-1
        voucherAccountMoney: voucherAccountPayMoney || 0, // 2
        goldMoney: isUsLocale ? 0 : totalGoldPayMoney, //
        goldAccount: this.agentAccountObj.goldAccount, // 2
        halfGoldAccount: this.agentAccountObj.halfGoldAccount, // 2
        payMethod: this.payType,
        deliveryMoney: isUsLocale ? 0 : deliveryMoney,
        promoteMoney: isUsLocale ? 0 : promoteMoney,
      }
      if(this.payApi == "loan"){
        this.creditOrderPay(params)
        return
      }
      if (this.payApi == "lading") {
        this.ladingOrderPay(params)
        return
      }
      purchaseOrderPay(params).then((ret) => {
        if (ret.code == 0) {
          if (this.dialogPayType == "submitAndAgentPay") {
            this.agentPay();
          } else {
            this.$message.success(this.$t('equipment.paymentSuccess'));
            this.payDialogVisible = false;
            this.callBackFn();
          }
        } else {
          // this.subCK = true;
          this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('equipment.paymentFail'));
        }
      });
      // }
    },
    // 赊货支付接口
    creditOrderPay(params){
      creditOrderPay(params).then(ret => {
        if (ret.code == 0) {
          if (this.dialogPayType == "submitAndAgentPay") {
            this.agentPay();
          } else {
            this.payDialogVisible = false;
            this.callBackFn();
          }
          this.$message.success(this.$t('equipment.paymentSuccess'));
        } else {
          this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('equipment.paymentFail'));
        }
      });
    },
    // 提货单支付接口
    ladingOrderPay(params){
      ladingPay(params).then(ret => {
        if (ret.code == 0) {
          if (this.dialogPayType == "submitAndAgentPay") {
            this.agentPay();
          } else {
            this.payDialogVisible = false;
            this.callBackFn();
          }
          this.$message.success(this.$t('equipment.paymentSuccess'));
        } else {
          this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('equipment.paymentFail'));
        }
      });
    },
    // 运费到付
    yufeidaofuSuccess() {
      this.showPaymentFeesDialog = false;
      this.freightVisiblePay = true;
    },
    // 提货单运费到付
    ladingYunfeidaofuSuccess() {
      this.showLadingFreightOrSave = false;
    },
    // 预收运费
    yushouyunfeiSuccess() {
      this.showPaymentFeesDialog = false;
      this.freightVisiblePay = true;
    },
    ladingYushouyunfeiSuccess() {
      this.showLadingFreightOrSave = false;
      this.ladingFreightVisiblePay = true;
    },
    closePaymentFeesDialog() {
      this.showPaymentFeesDialog = false;
      this.showLadingFreightOrSave = false;
      this.paymentLog = false;
    },
    cancelSubitPay() {
      this.dialogVisiblePay = false;
      this.freightVisiblePay = false;
      this.showLadingFreightOrSave = false;
      this.ladingFreightVisiblePay = false;
    },
    closeProcure2Pay() {
      this.dialogVisiblePay = false;
      this.freightVisiblePay = false;
      this.showLadingFreightOrSave = false;
      this.ladingFreightVisiblePay = false;
    },
    closeProcure3PayDialog() {
      this.procure3PayDialog = false;
    },
    closeBankRransfer() {
      this.bankRransferDialogVisible = false;
    },
    // 对公转账成功
    bankRransferSuccess() {
      this.bankRransferDialogVisible = false;
      this.callBackFn();
    },
    // 二次支付弹框取消
    payDialogCancel() {
      this.payDialogVisible = false;
    },
    hidePayResultDialog() {
      this.showPayResultDialog = false;
      this.procure3PayDialog = false;
      this.callBackFn();
    },
  },
};
</script>
<style scoped lang="scss">
.order-kouchu-wrap {
  text-align: center;
}
</style>
<style lang="scss">
.pay-result-dialog {
  .pay-result {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .el-dialog__footer {
    border-top: none;
  }
}
</style>
